AppTabs.createTab( {
name: 'lab-info',
icon: 'vial',
text: 'Lab Information',
create: function() {
    'use strict'

    return new TabControllerVue({
        el: '#vue-lab-info',
        data: {
			certificationId:        null,
			wiRegEngineersId:       null,
			wiDatcpCertificationId: null,
			membersOfList:          null,
			managerInitials:        null,
        },
        methods: {
			onShowTab() {
				const _this = this;
				window.ajaxCall({
					data : {
						action: 'get_lab_info',
					},
					successMessage: 'Successfully Retrieved Lab Information Settings',
					onSuccess: _this.setFromData,
				});
			},
			setFromData( { data } ) {
				this.certificationId        = data.certificationId;
				this.wiRegEngineersId       = data.wiRegEngineersId;
				this.wiDatcpCertificationId = data.wiDatcpCertificationId;
				this.membersOfList          = data.membersOfList;
				this.managerInitials        = data.managerInitials;
			},
			updateCertificationId() {
                const _this = this;
				window.ajaxCall({
					data: {
						action: 'update_lab_info',
						lab_info_data: { certificationId : _this.certificationId },
					},
					successMessage: 'Successfully Updated Certification ID',
					onSuccess: _this.setFromData,
				});
			},
			updateWiRegEngineersId() {
                const _this = this;
				window.ajaxCall({
					data: {
						action: 'update_lab_info',
						lab_info_data: { wiRegEngineersId : _this.wiRegEngineersId },
					},
					successMessage: 'Successfully Updated WI Reg Engineers ID',
					onSuccess: _this.setFromData,
				});
			},
			updateWiDatcpCertificationId() {
                const _this = this;
				window.ajaxCall({
					data: {
						action: 'update_lab_info',
						lab_info_data: { wiDatcpCertificationId : _this.wiDatcpCertificationId },
					},
					successMessage: 'Successfully Updated WI DATCP Certification ID',
					onSuccess: _this.setFromData,
				});
			},
			updateMembersOfList() {
                const _this = this;
				window.ajaxCall({
					data: {
						action: 'update_lab_info',
						lab_info_data: { membersOfList : _this.membersOfList },
					},
					successMessage: 'Successfully Updated WI DATCP Certification ID',
					onSuccess: _this.setFromData,
				});
			},
			updateManagerInitials() {
                const _this = this;
				window.ajaxCall({
					data: {
						action: 'update_lab_info',
						lab_info_data: { managerInitials : _this.managerInitials },
					},
					successMessage: 'Successfully Updated Manager Initials',
					onSuccess: _this.setFromData,
				});
			},
        },
    });

}

} );
